import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { BackgroundElement } from './elements';


import useDevice from 'hooks/useDevice';


import logo5 from 'assets/img/osperb/clients/client-05.jpg'
import logo6 from 'assets/img/osperb/clients/client-06.jpg'
import logo7 from 'assets/img/osperb/clients/client-07.jpg'
import logo8 from 'assets/img/osperb/clients/client-08.jpg'
import logo9 from 'assets/img/osperb/clients/client-09.jpg'
import logo10 from 'assets/img/osperb/clients/client-10.jpg'
import logo11 from 'assets/img/osperb/clients/client-11.jpg'
import logo12 from 'assets/img/osperb/clients/client-12.jpg'
// row 2
import logo13 from 'assets/img/osperb/clients/client-13.jpg'
import logo14 from 'assets/img/osperb/clients/client-14.jpg'
import logo15 from 'assets/img/osperb/clients/client-15.jpg'
import logo16 from 'assets/img/osperb/clients/client-16.jpg'
import logo17 from 'assets/img/osperb/clients/client-17.jpg'
import logo18 from 'assets/img/osperb/clients/client-18.jpg'
import logo19 from 'assets/img/osperb/clients/client-19.jpg'
import logo20 from 'assets/img/osperb/clients/client-20.jpg'
// row 3
import logo21 from 'assets/img/osperb/clients/client-21.jpg'
import logo22 from 'assets/img/osperb/clients/client-22.jpg'
import logo23 from 'assets/img/osperb/clients/client-23.jpg'
import logo24 from 'assets/img/osperb/clients/client-24.jpg'
import logo25 from 'assets/img/osperb/clients/client-25.jpg'
import logo26 from 'assets/img/osperb/clients/client-26.jpg'
import logo27 from 'assets/img/osperb/clients/client-27.jpg'
import logo28 from 'assets/img/osperb/clients/client-28.jpg'
// row 4
import logo29 from 'assets/img/osperb/clients/client-29.jpg'
import logo30 from 'assets/img/osperb/clients/client-30.jpg'
import logo31 from 'assets/img/osperb/clients/client-31.jpg'
import logo32 from 'assets/img/osperb/clients/client-32.jpg'
import logo33 from 'assets/img/osperb/clients/client-33.jpg'
import logo34 from 'assets/img/osperb/clients/client-34.jpg'
import logo35 from 'assets/img/osperb/clients/client-35.jpg'
import logo36 from 'assets/img/osperb/clients/client-36.jpg'


function Partners({ type }: { type: 'web' | 'mobile' }) {
    const { screenWidth, isMobile } = useDevice();
    // Partner logos organized by rows with different sizes
    const row1 = [
        { name: 'Loha', logo: logo5, size: 'small' },
        { name: 'Indtech', logo: logo6, size: 'small' },
        { name: 'Focus', logo: logo7, size: 'small' },
        { name: 'Zest-on', logo: logo8, size: 'small' },
        { name: 'Charcoal-bay', logo: logo9, size: 'small' },
        { name: 'Manjoora', logo: logo10, size: 'small' },
        { name: 'Ipas', logo: logo11, size: 'small' },
        { name: 'Cloud-rest', logo: logo12, size: 'small' },
    ];

    const row2 = [
        { name: 'WTI', logo: logo13, size: 'small' },
        { name: 'Britco-Bridco', logo: logo14, size: 'small' },
        { name: 'Al-khalili', logo: logo15, size: 'small' },
        { name: 'Supriya', logo: logo16, size: 'small' },
        { name: 'Corbal', logo: logo17, size: 'small' },
        { name: 'Sabka', logo: logo18, size: 'small' },
        { name: 'Elite', logo: logo19, size: 'small' },
        { name: 'Atelier', logo: logo20, size: 'small' },
    ];

    const row3 = [
        { name: 'Buildex', logo: logo21, size: 'small' },
        { name: 'Scale-Up', logo: logo22, size: 'small' },
        { name: 'Chocochi', logo: logo23, size: 'small' },
        { name: 'Khaf', logo: logo24, size: 'small' },
        { name: 'Toys-inside', logo: logo25, size: 'small' },
        { name: 'Deals2Home', logo: logo26, size: 'small' },
        { name: 'Tech-man', logo: logo27, size: 'small' },
        { name: 'Insite', logo: logo28, size: 'small' },
    ];

    const row4 = [
        { name: 'Stem-Xpert', logo: logo29, size: 'small' },
        { name: 'Covo', logo: logo30, size: 'small' },
        { name: 'Babyday', logo: logo31, size: 'small' },
        { name: 'Zeal-curtains', logo: logo32, size: 'small' },
        { name: 'F-zone', logo: logo33, size: 'small' },
        { name: 'Foodwey', logo: logo34, size: 'small' },
        { name: 'Gamio', logo: logo35, size: 'small' },
        { name: 'Grampoo', logo: logo36, size: 'small' },
    ];

    const isWeb = type === 'web';

    const scrollRef = useRef<HTMLDivElement>(null);

    const handleScroll = () => {
        const container = scrollRef.current;
        if (!container) return;

        const { scrollLeft, scrollWidth } = container;
        const oneThird = scrollWidth / 3;
        const threshold = 10;

        if (scrollLeft <= threshold) {
            container.scrollLeft = oneThird + scrollLeft;
        } else if (scrollLeft >= 2 * oneThird - threshold) {
            container.scrollLeft = scrollLeft - oneThird;
        }
    };

    const initializeScroll = () => {
        const container = scrollRef.current;
        if (container) {
            const oneThird = container.scrollWidth / 3;
            if (container.scrollLeft < 50 && oneThird > 0) {
                container.scrollLeft = oneThird;
            }
        }
    };

    useEffect(() => {
        initializeScroll();
    }, []);

    const getSizeStyles = (size: string) => {
        switch (size) {
            case 'large':
                return { width: '200px', height: '180px' };
            case 'medium':
                return { width: '160px', height: '140px' };
            case 'small':
                return { width: '80px', height: '80px' };
            default:
                return { width: '160px', height: '140px' };
        }
    };



    const renderPartner = (partner: any, index: number) => (
        <Box
            key={index}
            sx={{
                ...getSizeStyles(partner.size),
                backgroundColor: partner.bgColor,
                borderRadius: '12px',
                cornerShape: 'squircle', // custom prop is valid
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0px',
                flexShrink: 0,
                margin: 'auto', // Center in the column
            }}
        >
            {partner.logo ? (
                <Box
                    component="img"
                    src={partner.logo}
                    alt={`${partner.name} - Custom Software Partner Kerala`}
                    title={`${partner.name} - Trusted Client of Osperb Software Company`}
                    onLoad={initializeScroll}
                    sx={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                    }}
                />
            ) : (
                <Typography
                    sx={{
                        color: partner.bgColor === '#3A3A3A' ? 'white' : '#333',
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '0.875rem',
                        fontWeight: 600,
                    }}
                >
                    {partner.name}
                </Typography>
            )}
        </Box>
    );

    return (
        <Box
            sx={{
                backgroundColor: 'white',
                cornerShape: 'squircle',
                borderRadius: '40px',
                padding: '60px 0 40px',
                mt: -5,
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {/* Header with checkmark */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1.5,
                    mb: 4,
                    px: 3,
                }}
            >
                <CheckCircleIcon
                    sx={{
                        color: '#4CAF50',
                        fontSize: '2rem',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                    }}
                />
                <Typography
                    variant="h5"
                    className='font-satoshi-regular'
                    sx={{
                        color: "#333333",
                        fontSize: screenWidth < 330 ? '21px' : '24px',
                        fontWeight: 400,
                    }}
                >
                    You're in the right place.
                </Typography>
                <BackgroundElement
                    sx={{
                        top: '-1rem',
                        right: '2rem',
                    }}
                />
            </Box>

            {/* Description Text */}
            <Typography
                variant="body1"
                className='font-satoshi-regular'
                sx={{
                    color: '#0B1E53',
                    fontSize: '18px',
                    lineHeight: 1.6,
                    textAlign: 'center',
                    mb: 5,
                    px: 3,
                    width: screenWidth < 330 ? "100%" : "75%",
                    margin: "auto"
                }}
            >
                For <Box component="span" sx={{ fontWeight: 700 }}>8 years</Box>, we've partnered
                with organizations of every size:{' '}{isWeb ? <br /> : ''}
                <Box component="span" sx={{ fontWeight: 700 }}>global enterprises</Box>,{' '}
                <Box component="span" sx={{ fontWeight: 700 }}>startups</Box>,{' '}
                <Box component="span" sx={{ fontWeight: 700 }}>SMEs</Box>, and{' '}
                <Box component="span" sx={{ fontWeight: 700 }}>NGOs</Box>.
            </Typography>

            {/* Sliding Partner Logos Slider */}
            <Box
                ref={scrollRef}
                onScroll={handleScroll}
                sx={{
                    width: '100%',
                    mt: isWeb ? 10 : 5,
                    position: 'relative',
                    pb: 4,
                    scrollbarWidth: 'none',
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    },
                    overflowX: 'auto',

                }}>
                {[
                    [...row1, ...row1, ...row1],
                    [...row2, ...row2, ...row2],
                    [...row3, ...row3, ...row3],
                    [...row4, ...row4, ...row4],
                ].map((row, rowIndex) => (
                    <Box key={rowIndex} sx={{
                        whiteSpace: 'nowrap',
                        px: 2,
                        display: 'flex',
                        gap: isMobile ? '5px' : '10px',
                        mt: isMobile ? "-17px" : "0",
                    }}>
                        {row.map((partner, index) => renderPartner(partner, index))}
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default Partners;
